export enum LensCuttingMachineIntegrationStatus {
  Error = -1,
  PendingGeneration = 0,
  PendingIntegration = 1,
  Integrating = 2,
  Integrated = 3
}